import { createProjectMaintenanceWidget } from './projectMaintenanceWidget';
import { createMaintenancePhotoDrawingWidget } from './photoDrawingGalleryWidget';

export const sheetContentWidgetFactories = [
	createProjectMaintenanceWidget,
	createMaintenancePhotoDrawingWidget,
];